import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    background: theme.secondary.s1,
    borderRadius: theme.borderRadius.sm,
    padding: '4px 8px',
    minHeight: 20,
    gap: 4,
    width: 'fit-content',
  },
  tokensWeight: {
    ...dFlex(),
    gap: 8,
  },
  weight: {
    width: 18,
  },
}));

export default useStyles;
